import React from "react";
import '../Assets/css/BouncingDotsLoader.css';

const BouncingDotsLoader = ({ themeMode }) => {
  const dotColor = themeMode === 'dark' ? '#FFFFFF' : '#000000';

  return (
    <>
      <div
        className="bouncing-loader"
        style={{ '--dot-color': dotColor }}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default BouncingDotsLoader;
